import React, { Component } from 'react';
import { connect } from 'react-redux'


import { CardBody, Card, Row, Col,  FormGroup, Label, Button  } from 'reactstrap';

import { CenterMessageCard } from 'components/CenterMessageCard';


import { adminActions } from '../actions';
import { attendanceActions } from '../../courses/actions/attendanceActions';

import Select from "react-select";
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';

import './SchoolAttendance.css';

var DatePicker = require("reactstrap-date-picker");

var sdf = require('date-format');
var Const = require ('Const');
var ReportConst = require('components/Reports/Const');

class SchoolAttendance extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isCreatingReport: false,
      currentTopLevel: 'PRIM',
      currentShift: '18', 
      currentDate: sdf.asString('yyyy-MM-dd', new Date()),
      formattedCurrentDate: sdf.asString('dd/MM/yyyy', new Date())
    };
  }

  setModalOpen ( st ) {
    this.setState({ modalOpen: st }) ;

  }


       componentDidMount() {
        this.props.getAttencance( this.props.token, this.props.currentCalendarID, this.state.currentTopLevel,
                   this.state.currentShift, this.state.currentDate); 
        this.props.getAttendanceTypes ( this.props.token );
        
      }


 
      isAuth () {
        // if(this.props.user.user_type === 'TUTOR') {
            // if (this.props.course.tutors.find((tutor) => tutor.persona_id === this.props.user.persona_id)) {
            //   return true;
            // } else {
            //   return false;
            // }
        // } else {
           return true;
        // }
      }

      setSelectedSchoolShift( shift ) {
        this.setState({currentShift: shift.value});
        this.props.getAttencance( this.props.token, this.props.currentCalendarID, this.state.currentTopLevel, 
                                  shift.value, this.state.currentDate); 
      }
      setSelectedTopLevel( lvl ) {
        this.setState({currentTopLevel: lvl.value});
        this.props.getAttencance( this.props.token, this.props.currentCalendarID, 
                                  lvl.value, this.state.currentShift, this.state.currentDate); 
      }

      setCurrentDate( date) {
        let newDate =  sdf.asString('yyyy-MM-dd', new Date(date) );
        this.setState(  {currentDate: newDate,
                        formattedCurrentDate: sdf.asString('dd/MM/yyyy', new Date(date) )
                      }); 


        this.props.getAttencance( this.props.token, this.props.currentCalendarID, this.state.currentTopLevel, 
                        this.state.currentShift, newDate); 
      }

      prepareContent() {

        // Table Header
    //     curso
        let widths = [120];
        let colsHead = ['Curso']

        let totals = {enrolled:0, present:0 };

        widths.push('*');
        colsHead.push( { text: 'Presentes', alignment: 'center' } );
        
        this.props.attendanceTypes.map( (att) => {
          totals[att.type_id] = 0;
          widths.push('*');
          colsHead.push( { text: att.description, alignment: 'center' } );
        });

        widths.push('*');
        colsHead.push( { text: 'Total', alignment: 'center' } );
        widths.push('*');
        colsHead.push( { text: 'Validado', alignment: 'center' } );
        
        
        let table = [colsHead];
        
        this.props.dayAttendance.map( (row) => {
          let thisRow = [ row.name + ' - Turno ' + row.shift_name] ;
          if (row.att_status==='Y') {
            totals.present = totals.present + (row.enrolled - (row['AU']?row['AU']:0)) ;
            thisRow.push( { text: (row.enrolled - (row['AU']?row['AU']:0)), alignment: 'center' } );
          } else {
            thisRow.push( { text: '', alignment: 'center' } );
          }

          this.props.attendanceTypes.map( (att) => {
            totals[att.type_id] = totals[att.type_id] + (row[att.type_id]? row[att.type_id]:0);
            thisRow.push( { text: row[att.type_id], alignment: 'center' } );
             
          })
          if (row.att_status==='Y') {
            thisRow.push( { text: row.enrolled, alignment: 'center' }, { text: 'SI' , alignment: 'center' } );
            totals.enrolled = totals.enrolled + row.enrolled;
          } else {
            thisRow.push( { text: '', alignment: 'center' } , { text: '' , alignment: 'center' } );
            
          }
          
         
          
          

          table.push(thisRow)
        }) ;

        let tot = [ { text: "Total", alignment: 'right' },  { text: totals.present, alignment: 'center' }] ;
        this.props.attendanceTypes.map( (att) => {
          tot.push( { text: totals[att.type_id], alignment: 'center' } );
        })
        tot.push( { text: totals.enrolled, alignment: 'center' } );
        tot.push( { text: '', alignment: 'center' } );
        
        table.push(tot);
        return (
          {
            style: 'tableHeader',
            table: {
              widths: widths,
              body: table
            }
          }
        )
      }

      downloadReport() {
        
        // viewActions.notification({message:'El documento ya se esta generando, luego de unos segundos iniciará la descarga.',
        // title:'Descarga',type:'success'});

        const {vfs} = vfsFonts.pdfMake;
        pdfMake.vfs = vfs;
        const documentDefinition = {
          info: {
            title: 'Parte diario de asistencias - Turno ' + 
                    Const.getObjectByValue(Const.SCHOOL_SHIFTS,this.state.currentShift).label
                      + '  ' + this.state.formattedCurrentDate
          },        
          pageSize: 'A4',
          pageOrientation: 'landscape',
          pageMargins: [40, 70, 40, 60],

          header: ReportConst.header,
          styles: ReportConst.styles,
          content: [
            { text: 'Parte diario de asistencias - Turno ' + 
                  Const.getObjectByValue(Const.SCHOOL_SHIFTS,this.state.currentShift).label
            + '  ' + this.state.formattedCurrentDate , style: 'header' },
            this.prepareContent()
          ],
          footer: ReportConst.footer,
          // styles: json.styles
        } ;
        
        pdfMake.createPdf(documentDefinition).open();

      }

     render() {
      let totals = {enrolled:0, present:0 };
      this.props.attendanceTypes.map( (att) => {  totals[att.type_id] = 0 });

      return (
            <>
              {this.isAuth()?
                <div className="content"> 
                 <Card>
                    <CardBody>
                       <Row>
                          <Col sm="3"> 
                            <FormGroup>
                              <Label>Nivel educativo</Label>
                              <Select
                                      name="current"
                                      defaultValue= { Const.TOP_LEVELS[0]}
                                      onChange={(sel) => this.setSelectedTopLevel(sel)}
                                      options={Const.TOP_LEVELS}
                                      placeholder="Seleccione nivel"
                                    />
                            </FormGroup>
                          </Col>
                          <Col sm="3"> 
                            <FormGroup>
                              <Label>Turno</Label>
                              <Select
                                      name="currentShitf"
                                      defaultValue= { Const.SCHOOL_SHIFTS[0]}
                                      onChange={(sel) => this.setSelectedSchoolShift(sel)}
                                      options={Const.SCHOOL_SHIFTS}
                                      placeholder="Seleccione turno"
                                    />
                            </FormGroup>
                          </Col>
                          <Col sm="3">
                            <FormGroup>
                              <Label>Fecha a mostrar</Label>
                              <DatePicker 
                                id = "example-datepicker" 
                                showClearButton={false}
                                value ={ this.state.currentDate } 
                                onChange={(newDate) => this.setCurrentDate( newDate ) }
                                dayLabels={Const.WEEK_DAYS_SHORT}
                                monthLabels={Const.MONTHS}
                                  />
                          
                          </FormGroup>
                          </Col>
                          <Col sm="3">
                              <Button 
                                  style={{marginTop: "26px"}}
                                  color="success" 
                                  disabled={this.props.view.isLoading} 
                                  onClick={() => this.downloadReport()}
                                  >
                              {this.state.isCreatingReport?
                                <i className="nc-icon nc-refresh-69  fa-spin" />
                              :
                              <>
                                <span className="btn-label">
                                  <i className="fa fa-floppy-o" aria-hidden="true"></i>
                                </span>
                                Descargar informe
                              </>
                              }
                              </Button>

                          </Col>
                        </Row>
                    </CardBody>
                  </Card>
                  <Card>
                    <CardBody>
                       <Row>
                        <Col sm="12">
                            <table>
                            <tbody>
                              <tr>
                                  <td width="30%">Curso</td>
                                  <td width={''+ (70/(this.props.attendanceTypes.length+3) + '%')}
                                             className="type-head">Presente</td>
                                  {this.props.attendanceTypes.map( (att) => {
                                       return ( <td width={''+  (70/(this.props.attendanceTypes.length+2) + '%')}
                                             className="type-head">{att.description}</td> )
                                  })}
                                  <td width={''+  (70/(this.props.attendanceTypes.length+3) + '%')}
                                             className="type-head">Total</td>
                                  <td width={''+  (70/(this.props.attendanceTypes.length+3) + '%')}
                                             className="type-head">Validado</td>
                              </tr>
                              
                              { this.props.dayAttendance.map( (row,idx) => {
                                if (row.att_status==='Y') {
                                  totals.present = totals.present + (row.enrolled - (row['AU']?row['AU']:0));
                                  totals.enrolled = totals.enrolled + row.enrolled ;
                                }
                                return(
                                  <>

                                    <tr bgcolor={idx%2===0?"#f0f0f0":""}>
                                      <td>{row.name} - Turno {row.shift_name}</td>
                                      <td className='att-cell'>
                                          {row.att_status==='Y'?
                                            row.enrolled - (row['AU']?row['AU']:0)
                                          :  
                                            <></>
                                        }
                                      </td>
                                     
                                      {this.props.attendanceTypes.map( (att) => {
                                         totals[att.type_id] = totals[att.type_id] + (row[att.type_id]? row[att.type_id]:0);
                                         return ( <td className='att-cell'>{row[att.type_id]}</td> )
                                      })}
                                      
                                      
                                       <td className='att-cell'> {row.att_status==='Y'? row.enrolled: <></>}</td>
                                       <td className='att-cell'>{row.att_status==='Y'?'✓':'' }</td>
                                    </tr>
                                    </>
                                )

                              })}

                              <tr bgcolor="#c0c0c0">
                                <td  className='type-foot' align='right'>Total</td> 
                                <td className='type-foot'>{totals.present}</td>
                                {this.props.attendanceTypes.map( (att) => {
                                    return ( <td className='type-foot'>{totals[att.type_id]}</td> )
                                })}
                                  <td className='type-foot'>{totals.enrolled }</td>
                                  <td className='type-foot'></td>
                              </tr>

                              </tbody>

                            </table>
  
                        </Col>
                      </Row> 
                    
                    </CardBody>
                  </Card>
                  <p>
                    Por más que el encargado haya cargado las inasistencias del día, hasta que no las valida no aparecerán reflejados aquí los totales de alumnos
                    presentes ni el total general de inscriptos por curso

                  </p>
                  </div>
              :
                <CenterMessageCard 
                    icon="fa-info"
                    title="Autorización requerida">
                      No tenés permisos para acceder a esta sección. En caso que lo requieras solicita al administrador que 
                      te agregue
                </CenterMessageCard>  
               }
              </>
          );
    }
  }


  const mapStateToProps = state => {
    return {
      token: state.auth.session.jwt_token,
      
      
      attendanceTypes: state.courses.attendanceTypes,
      currentCalendarID: state.school.currentCalendarID,
      dayAttendance: state.admin.dayAttendance,
      view: state.view,
        // user: state.auth.session.user
    }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
        getAttencance: ( token, calendarID, topLevelID, shift, date ) => {
          dispatch( adminActions.getAttencance ( token, calendarID, topLevelID, shift,  date ) );
        },
        getAttendanceTypes: ( token ) => {
          dispatch( attendanceActions.getAttendanceTypes( token ))
        }

     }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(SchoolAttendance);

